export const BILLING_STATEMENT_STATUS = Object.freeze({
    PAID: 'paid',
    OVERDUE: 'overdue',
    PENDING: 'pending',
});

export const BILLING_TIMEFRAME_SEARCH_PARAM_KEY = 'period';
export const BILLING_DATE_RANGE_SEARCH_PARAM_KEY = 'range';
export const BILLING_DEFAULT_TIMEFRAME = '3m';
